var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"site-header"},[_c('div',{staticClass:"header-content"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":"安徽省数字文化产业创新研究院"}})]),_c('div',{staticClass:"right-section"})])])
}]

export { render, staticRenderFns }